import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🍭 Design`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Figma:`}</strong>{` Thumbprint Web has been Migrated to figma and ready for use by design.`}</li>
      <li parentName="ul"><strong parentName="li">{`Figma Brownbags:`}</strong>{` Jon K. will be leading a number of sessions to help people ramp up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Thumbprint Native:`}</strong>{` Work is underway on the spacing toolkit for native.`}</li>
    </ul>
    <h2>{`💾 API`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Aspect ratios:`}</strong>{` As part of the Image Toolkit we’ve added Atomic classes and pattern documentation to support aspect ratios.`}</li>
      <li parentName="ul"><strong parentName="li">{`Performance improvements:`}</strong>{` We’re working with the Growth team to test performance changes to the Instant Results page. This includes converting code to use Thumbprint Atomic as well as inlining CSS in the `}<inlineCode parentName="li">{`<head>`}</inlineCode>{` tag.`}</li>
      <li parentName="ul"><strong parentName="li">{`Contributions:`}</strong>{` Thanks to Mark M. and Dan C. for `}<a parentName="li" {...{
          "href": "https://github.com/thumbtack/thumbprint-archive/issues/1033"
        }}>{`fixing a bug in Tooltip`}</a>{` and `}<a parentName="li" {...{
          "href": "https://github.com/thumbtack/thumbprint-archive/pull/1320"
        }}>{`adding `}<inlineCode parentName="a">{`onKeyDown`}</inlineCode></a>{` to the `}<inlineCode parentName="li">{`Input`}</inlineCode>{` component.`}</li>
      <li parentName="ul"><strong parentName="li">{`Behind the scenes infrastructure:`}</strong>{` All Thumbprint examples are now using `}<inlineCode parentName="li">{`README.mdx`}</inlineCode>{` files. `}<a parentName="li" {...{
          "href": "https://github.com/thumbtack/thumbprint-archive/issues/1251"
        }}>{`Learn more about the change`}</a>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      